import React, { useContext, useEffect } from "react";
import { Line } from "react-chartjs-2";
import { AssociateScanContext } from "./context/AssociateScanContext";
import { getRefreshInterval } from "../util/Util";

const AssociateScanChart = () => {
    const { viewModel, dispatch } = useContext(AssociateScanContext);

    const getData = () => {
        dispatch({ type: 'LOAD_DATA', data: { dispatcher: dispatch } });
    };

    useEffect(() => {
        getData();
        const interval = setInterval(() => {
            if (!document.hidden) {
                getData();
            }
        }, getRefreshInterval());
        return () => clearInterval(interval);
    }, []);

    const getChartData = () => {
        const { scanMetrics, chartData } = viewModel;
        const { selectedAssociates, granularity } = chartData;

        if (!scanMetrics || !scanMetrics[granularity] || Object.keys(scanMetrics[granularity]).length === 0) {
            return { labels: [], datasets: [] };
        }

        const granularityData = scanMetrics[granularity];

        // Always get time labels from any available associate's data
        const availableAssociates = Object.keys(granularityData);
        const labels = availableAssociates.length > 0 && granularityData[availableAssociates[0]] && Array.isArray(granularityData[availableAssociates[0]]) ?
            granularityData[availableAssociates[0]].map(item =>
                new Date(item.timeStampVal)
                    .toTimeString()
                    .split(" ")[0]
                    .split(":")[0] +
                ":" +
                new Date(item.timeStampVal)
                    .toTimeString()
                    .split(" ")[0]
                    .split(":")[1]
            ) : [];

        // Create datasets only for selected associates
        const datasets = selectedAssociates.map((email, index) => {
            const associateData = granularityData[email];
            if (!associateData || !Array.isArray(associateData)) return null;

            return {
                label: email.replace('@amazon.com', ''),
                data: associateData.map(item => item.metricValue || 0),
                borderColor: generateColor(index),
                fill: false,
            };
        }).filter(Boolean);

        return { labels, datasets };
    };

    // Generate unlimited colors using HSL color space
    const generateColor = (index) => {
        const hue = (index * 137.508) % 360; // Golden angle approximation for good color distribution
        const saturation = 70 + (index % 3) * 10; // Vary saturation slightly
        const lightness = 45 + (index % 4) * 5; // Vary lightness slightly
        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    };

    const chartOptions = {
        maintainAspectRatio: false,
        legend: {
            display: true,
            position: 'bottom',
        },
        scales: {
            xAxes: [
                {
                    gridLines: {
                        drawOnChartArea: false,
                    },
                },
            ],
            yAxes: [
                {
                    gridLines: {
                        drawOnChartArea: false,
                    },
                    ticks: {
                        autoSkip: true,
                        maxTicksLimit: 5,
                    },
                },
            ],
        },
    };

    return (
        <Line data={getChartData()} options={chartOptions} />
    );
};

export default AssociateScanChart;


// WEBPACK FOOTER //
// ./src/components/associate/AssociateScanChart.js